import { Component, input } from '@angular/core';
import { Reviewee } from '../../models';

@Component({
  selector: 'app-employee-card',
  templateUrl: './employee-card.component.html',
  styleUrls: ['./employee-card.component.scss'],
  standalone: true,
})
export class EmployeeCardComponent {
  readonly employee = input<Reviewee>(undefined);
}
